'use client';

import { useRef, useEffect } from 'react';

/** Horizontal connector line that draws left-to-right when it enters the viewport. */
export function ConnectorLine() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          el.dataset.visible = 'true';
          obs.disconnect();
        }
      },
      { threshold: 0.5 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="pointer-events-none absolute top-[52px] left-[calc(12.5%+28px)] right-[calc(12.5%+28px)] hidden h-px lg:block"
      style={{
        background:
          'linear-gradient(to right, transparent, hsl(202 78% 53% / 0.30) 20%, hsl(202 78% 53% / 0.30) 80%, transparent)',
      }}
    >
      {/* Animated fill line over the static track */}
      <div
        className="connector-line absolute inset-0"
        style={{
          background:
            'linear-gradient(to right, hsl(202 78% 60% / 0.6), hsl(202 78% 70% / 0.3))',
        }}
      />
    </div>
  );
}
